import React, { useEffect, useState } from "react";
import TextField from "../Components/Inputs/TextField";
import SelectTag from "../Components/Inputs/SelectTag";
import CustomAutoComplete from "../Components/Inputs/CustomAutoComplete";
import { getCountriesData } from "../../../Redux/Apis/Global-Apis";

function PassportDetailsEdit({ generalDetails, onClickCancel, onClickSave }) {
  let [editableGeneralDetails, setEditableGeneralDetails] =
    useState(generalDetails);

  let [issuanceDateError, setIssuanceDateError] = useState("");
  let [expiryDateError, setExpiryDateError] = useState("");

  const checkValidations = () => {
    if (
      editableGeneralDetails.passport_issue_date == null &&
      editableGeneralDetails.passport_expiry_date == null
    )
      return true;

    let status = 0;
    if (editableGeneralDetails.passport_issue_date != null) {
      let issue = editableGeneralDetails.passport_issue_date.trim(); // Ensure no extra spaces

      // Check for incomplete date
      if (
        issue.includes("DD") ||
        issue.includes("MM") ||
        issue.includes("YYYY")
      ) {
        setIssuanceDateError("Incomplete Date");
        setTimeout(() => setIssuanceDateError(""), 3000); // Clear error after 3 seconds
        status++;
      }

      // Check if dob is a future date
      let dobDate = new Date(issue);
      let today = new Date();

      if (dobDate > today) {
        setIssuanceDateError("Passport Issue Date Can't be a Future Date");
        setTimeout(() => setIssuanceDateError(""), 3000); // Clear error after 3 seconds
        status++;
      }
    }

    if (editableGeneralDetails.passport_expiry_date != null) {
      let issue = editableGeneralDetails.passport_expiry_date.trim(); // Ensure no extra spaces

      // Check for incomplete date
      if (
        issue.includes("DD") ||
        issue.includes("MM") ||
        issue.includes("YYYY")
      ) {
        setExpiryDateError("Incomplete Date");
        setTimeout(() => setExpiryDateError(""), 3000); // Clear error after 3 seconds
        status++;
      }

      // Check if dob is a future date
      let dobDate = new Date(issue);
      let today = new Date();

      if (dobDate <= today) {
        setExpiryDateError("Your Passport is Expired");
        setTimeout(() => setExpiryDateError(""), 3000); // Clear error after 3 seconds
        status++;
      }
    }

    return status == 0;
  };

  let saveTheData = () => {
    // apply validations here and chekc them in the end do below
    let isAllValid = checkValidations();

    if (isAllValid == true) {
      onClickSave(editableGeneralDetails, "passport");
    }
  };

  const days = Array.from({ length: 31 }, (_, i) => ({
    label: i + 1 < 10 ? `0${i + 1}` : i + 1,
    value: i + 1,
  }));

  const months = [
    { label: "MM", value: "MM" },
    { label: "Jan", value: "01" },
    { label: "Feb", value: "02" },
    { label: "Mar", value: "03" },
    { label: "Apr", value: "04" },
    { label: "May", value: "05" },
    { label: "Jun", value: "06" },
    { label: "Jul", value: "07" },
    { label: "Aug", value: "08" },
    { label: "Sep", value: "09" },
    { label: "Oct", value: "10" },
    { label: "Nov", value: "11" },
    { label: "Dec", value: "12" },
  ];
  const currentYear = new Date().getFullYear();

  let getYears = (sign) => {
    const operations = {
      "+": (a, b) => a + b,
      "-": (a, b) => a - b,
      "*": (a, b) => a * b,
      "/": (a, b) => a / b,
    };

    if (!operations[sign]) {
      console.error("Invalid operator. Use +, -, *, or /");
      return [];
    }

    return Array.from({ length: 100 }, (_, i) => ({
      label: operations[sign](currentYear, i),
      value: operations[sign](currentYear, i),
    }));
  };

  let onChangeInput = (e) => {
    setEditableGeneralDetails((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onChangeDate = (field, value, key) => {
    let prevDate =
      editableGeneralDetails?.[key] == null
        ? "YYYY-MM-DD"
        : editableGeneralDetails?.[key];

    let currentDOB = prevDate ? prevDate.split("-") : ["YYYY", "MM", "DD"];

    if (field === "day") currentDOB[2] = value.value;
    if (field === "month") currentDOB[1] = value.value;
    if (field === "year") currentDOB[0] = value.value;
    let finalDob = currentDOB.join("-");

    setEditableGeneralDetails((prev) => {
      return {
        ...prev,
        [key]: finalDob,
      };
    });
  };

  let getDateValue = (val) => {
    if (!val) return { label: "DD", value: null };
    return { label: val, value: val };
  };

  let getMonthValue = (val) => {
    if (!val) return { label: "MM", value: null };
    return {
      label: months.filter((item) => item.value == val)[0].label,
      value: val,
    };
  };

  let getYearValue = (val) => {
    if (!val) return { label: "YYYY", value: null };
    return { label: val, value: val };
  };

  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      let data = await getCountriesData();

      if (data.length > 0) {
        let dd = data.map((item) => ({
          label: item.name,
          value: item.code,
          data: item,
        }));

        setCountries(dd);
      }
    };

    fetchCountries();
  }, []);

  let getCountryValue = (val) => {
    if (!val) return { label: "Select Country", value: null, data: null };

    return {
      label: val.name,
      value: val.code,
      data: val,
    };
  };

  let onChangeCountry = (value) => {
    console.log("countrychange value si : ", value);

    setEditableGeneralDetails((prev) => ({
      ...prev,
      passport_issuing_country: value.data,
      passport_issuing_country_id: value.data.code,
    }));
  };

  return (
    <div className="userdb-content-right-internal-top">
      <div className="internal-tab-head">
        <h3>Passport Details</h3>
        <div className="editable-profile-action">
          <ul class="userdb-cta-buttons">
            <li class="userdb-cancel-btn" onClick={() => onClickCancel(false)}>
              Cancel
            </li>
            <li class="userdb-save-btn" onClick={() => saveTheData()}>
              Save
            </li>
          </ul>
        </div>
      </div>
      <ul className="myprofile-general-details">
        <li>
          <label for="">Passport No.</label>
          <div style={{ display: "flex", width: "70%", marginLeft: "2px" }}>
            <TextField
              focus={true}
              onChange={onChangeInput}
              name="passport_number"
              value={editableGeneralDetails.passport_number}
            />
          </div>
        </li>

        <li>
          <label for="">Passport Expiry Date</label>
          <div className="date-input-wrapper">
            <div className="date-wrapper">
              <SelectTag
                value={getDateValue(
                  editableGeneralDetails?.passport_expiry_date?.split("-")?.[2]
                )}
                options={[{ label: "DD", value: null }, ...days]}
                toSkip="DD"
                width="40px"
                dropdownWidth={"60px"}
                onChange={(value) =>
                  onChangeDate("day", value, "passport_expiry_date")
                }
              />

              <SelectTag
                value={getMonthValue(
                  editableGeneralDetails?.passport_expiry_date?.split("-")?.[1]
                )}
                width="40px"
                options={months}
                toSkip="MM"
                dropdownWidth={"80px"}
                onChange={(value) =>
                  onChangeDate("month", value, "passport_expiry_date")
                }
              />

              <SelectTag
                value={getYearValue(
                  editableGeneralDetails?.passport_expiry_date?.split("-")?.[0]
                )}
                width="60px"
                options={[{ label: "YYYY", value: null }, ...getYears("+")]}
                toSkip="YYYY"
                dropdownWidth={"80px"}
                onChange={(value) =>
                  onChangeDate("year", value, "passport_expiry_date")
                }
              />
            </div>
            {!!expiryDateError && (
              <div className="error font12 color_crimson proxima_regular">
                {expiryDateError}
              </div>
            )}
          </div>
        </li>
        <li>
          <label for="">Passport Issue Date</label>
          <div className="date-input-wrapper">
            <div className="date-wrapper">
              <SelectTag
                value={getDateValue(
                  editableGeneralDetails?.passport_issue_date?.split("-")?.[2]
                )}
                options={[{ label: "DD", value: null }, ...days]}
                toSkip="DD"
                width="40px"
                dropdownWidth={"60px"}
                onChange={(value) =>
                  onChangeDate("day", value, "passport_issue_date")
                }
              />

              <SelectTag
                value={getMonthValue(
                  editableGeneralDetails?.passport_issue_date?.split("-")?.[1]
                )}
                width="40px"
                options={months}
                toSkip="MM"
                dropdownWidth={"80px"}
                onChange={(value) =>
                  onChangeDate("month", value, "passport_issue_date")
                }
              />

              <SelectTag
                value={getYearValue(
                  editableGeneralDetails?.passport_issue_date?.split("-")?.[0]
                )}
                width="60px"
                options={[{ label: "YYYY", value: null }, ...getYears("-")]}
                toSkip="YYYY"
                dropdownWidth={"80px"}
                onChange={(value) =>
                  onChangeDate("year", value, "passport_issue_date")
                }
              />
            </div>
            {!!issuanceDateError && (
              <div className="error font12 color_crimson proxima_regular">
                {issuanceDateError}
              </div>
            )}
          </div>
        </li>
        <li>
          <label for="">Issuing Country</label>
          <div style={{ display: "flex", width: "70%", marginLeft: "2px" }}>
            <CustomAutoComplete
              value={getCountryValue(
                editableGeneralDetails.passport_issuing_country
              )}
              options={countries}
              toSkip="Select Country"
              width="50px"
              dropdownWidth={"280px"}
              onChange={(value) => onChangeCountry(value)}
            />
          </div>
        </li>
      </ul>
    </div>
  );
}

export default PassportDetailsEdit;
